import React from "react";
import Modal from 'react-bootstrap/Modal';
import { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Info.scss"


export const Cost = ({ onClose }) => {

    const [show, setShow] = useState(true);
    let history = useHistory();

    const handleClose = () => {
        setShow(false);
        if (onClose) {
            onClose();
        } else {
            history.push({
                pathname: `/score`,
            });
        }
    };

    const handleConsult = () => {
        setShow(false);
        history.push({
            pathname: `/search`,
        });
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton style={{ border: "0px" }}>
            </Modal.Header>
            <Modal.Body>
                <div className="container cost-info">
                    <p className="px-xl-4 pb-2">
                        <strong>Con eGrade solo pagas por lo que consumes. </strong> Sin precio mínimo, ni permanencia.
                        <strong> Con una tarifa única</strong> de 5 euros más IVA, sea cual sea el país de origen de la empresa.
                        Consulta tantas veces como quieras el resultado del eGrade dentro del periodo de validez de 15 días.
                    </p>

                    <span className="px-xl-4 text-purple">¡Primera consulta gratis!</span>

                    <p className="px-xl-4">
                        Queremos premiar tu confianza ofreciéndote la <span className="text-purple">primera consulta de eGrade de forma gratuita</span>, para que pruebes el servicio y descubras las ventajas que te ofrece.
                        Solo tienes que añadir una empresa sobre la que quieras consultar el eGrade a la bolsa de compra, verás el descuento por el total del precio aplicado al momento.
                        No pierdas esta oportunidad, solicita ya tu primer eGrade.
                    </p>
                    <div className="flex row">
                        <button onClick={handleConsult} className="col-xl-6 col-11 cost-pill mt-2 py-1">Precio fijo de 5€ +IVA la consulta</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}